import { Link } from "react-router-dom";
import styled from "styled-components";

import { FontWeightType } from "@sso/types";

interface CustomLinkProps {
  color?: string;
  fontSize?: string;
  margin?: string;
  padding?: string;
  fontWeight?: FontWeightType;
  hoverColor?: string;
  hovertextdecoration?: string;
  textAlign?: "center" | "right" | "left" | "inherit" | "initial";
}
export const CustomLink = styled(Link)<CustomLinkProps>`
  text-decoration: none;
  color: ${p => p.color || p.theme.colors.text.primary};
  text-align: ${p => p.textAlign || "center"};
  ${p => p.fontSize && `font-size:${p.fontSize}`};
  ${p => p.margin && `margin:${p.margin}`};
  ${p => p.padding && `padding:${p.padding}`};
  ${p => p.fontWeight && `font-weight:${p.fontWeight}`};
  &:hover {
    text-decoration: ${p => p.hovertextdecoration || "underline"};
    ${p => p.hoverColor && `color:${p.hoverColor}`};
  }
`;
